
    import './styles.scoped.css';
    export default {
  "direction-button-wrapper": "awsui_direction-button-wrapper_155yk_qy3b6_169",
  "direction-button-wrapper-motion-enter": "awsui_direction-button-wrapper-motion-enter_155yk_qy3b6_189",
  "direction-button-wrapper-motion-entering": "awsui_direction-button-wrapper-motion-entering_155yk_qy3b6_189",
  "direction-button-wrapper-motion-exit": "awsui_direction-button-wrapper-motion-exit_155yk_qy3b6_189",
  "direction-button-wrapper-motion-exiting": "awsui_direction-button-wrapper-motion-exiting_155yk_qy3b6_189",
  "drag-handle-entry": "awsui_drag-handle-entry_155yk_qy3b6_1",
  "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_155yk_qy3b6_1",
  "drag-handle-exit": "awsui_drag-handle-exit_155yk_qy3b6_1",
  "awsui-motion-fade-out-0": "awsui_awsui-motion-fade-out-0_155yk_qy3b6_1",
  "direction-button-wrapper-block-start": "awsui_direction-button-wrapper-block-start_155yk_qy3b6_229",
  "direction-button-wrapper-block-end": "awsui_direction-button-wrapper-block-end_155yk_qy3b6_233",
  "direction-button-wrapper-inline-start": "awsui_direction-button-wrapper-inline-start_155yk_qy3b6_237",
  "direction-button-wrapper-inline-end": "awsui_direction-button-wrapper-inline-end_155yk_qy3b6_238",
  "direction-button-wrapper-rtl": "awsui_direction-button-wrapper-rtl_155yk_qy3b6_238",
  "drag-handle-wrapper": "awsui_drag-handle-wrapper_155yk_qy3b6_247",
  "portal-overlay": "awsui_portal-overlay_155yk_qy3b6_252",
  "portal-overlay-contents": "awsui_portal-overlay-contents_155yk_qy3b6_260",
  "drag-handle": "awsui_drag-handle_155yk_qy3b6_247",
  "direction-button-wrapper-hidden": "awsui_direction-button-wrapper-hidden_155yk_qy3b6_277",
  "direction-button": "awsui_direction-button_155yk_qy3b6_169",
  "direction-button-disabled": "awsui_direction-button-disabled_155yk_qy3b6_320"
};
  